export default __webpack_public_path__ + "static/media/IMG-2728.8a60ec04.jpg";